import React from 'react';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CellType } from '../modules/appLibrary';

//--------------------------------------------------------
//  検索パネル用Render
//
//--------------------------------------------------------
export default function RenderInput(props) {
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
    const CELLTYPE = CellType();
    const radioOptions = Array.isArray(props.data.options) ? props.data.options : [];

    function ButtonClick(e) {
        props.clicked(props);
    }
    function ClearClick(e) {
        props.clear(props);
    }
    function RadioChange(e) {
        if (!props.node || !props.colDef) return;
        props.node.setDataValue(props.colDef.field, e.target.value);
    }
    function RenderBody() {
        if (props.data.datatype === CELLTYPE.NUM || props.data.datatype === CELLTYPE.SEARCHNUM) {
            return (
                <div style={{ position: 'rerative' }}>
                    {cellValue}
                    <div style={{ position: 'absolute', top: 10, right: 5, cursor: 'pointer' }} onClick={ClearClick}>
                        <i class="material-icons delete">close</i>
                    </div>
                </div>
            );
        }
        if (props.data.datatype === CELLTYPE.DATE || props.data.datatype === CELLTYPE.SEARCHDATE || props.data.datatype === CELLTYPE.YEAR || 
            props.data.datatype === CELLTYPE.SEARCHYM || props.data.datatype === CELLTYPE.SEARCHYMRANGE ||
            props.data.datatype === CELLTYPE.SEARCHYMSTR || props.data.datatype === CELLTYPE.SEARCHYMRANGESTR ) {
            return (
                <div style={{ position: 'rerative' }}>
                    {cellValue}
                    <div style={{ position: 'absolute', top: 0, right: 20, cursor: 'pointer' }} onClick={ButtonClick}>
                        <IconButton size="small">
                            <Icon>arrow_right</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 10, right: 5, cursor: 'pointer' }} onClick={ClearClick}>
                        <i class="material-icons delete">close</i>
                    </div>
                </div>
            );
        }
        if (props.data.datatype === CELLTYPE.MASTER || props.data.datatype === CELLTYPE.SELECT ||
            props.data.datatype === CELLTYPE.MASTERREF || props.data.datatype === CELLTYPE.MASTERCODE ||
            props.data.datatype === CELLTYPE.CHECK || props.data.datatype === CELLTYPE.SPIN) {
            return (
                <div style={{ position: 'rerative' }}>
                    {cellValue}
                    <div style={{ position: 'absolute', top: 0, right: 20, cursor: 'pointer' }} onClick={ButtonClick}>
                        <IconButton size="small">
                            <Icon>arrow_right</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 10, right: 5, cursor: 'pointer' }} onClick={ClearClick}>
                        <i class="material-icons delete">close</i>
                    </div>
                </div>
            );
        }
        if (props.data.datatype === CELLTYPE.RADIO) {
            return (
                <div style={{ position: 'rerative', paddingRight: 20, marginLeft:10 }}>
                    <RadioGroup
                        row
                        value={props.value === undefined || props.value === null ? "" : String(props.value)}
                        onChange={RadioChange}
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            gap: 1,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '10px',
                                lineHeight: 1,
                            },
                            '& .MuiRadio-root': {
                                padding: '2px',
                            },
                            '& .MuiRadio-root.Mui-checked': {
                                color: '#87877c',
                            },
                        }}
                    >
                        {radioOptions.map((option) => (
                            <FormControlLabel
                                key={option.code}
                                value={String(option.code)}
                                control={<Radio size="small" />}
                                label={option.name}
                            />
                        ))}
                    </RadioGroup>
                </div>
            );
        }
        return (
            <div style={{ position: 'rerative' }}>
                {cellValue}
                <div style={{ position: 'absolute', top: 10, right: 5, cursor: 'pointer' }} onClick={ClearClick}>
                    <i class="material-icons delete">close</i>
                </div>
            </div>
        );
    }
    return (
        <RenderBody />
    );
}
